<template>
  <div class="my-order">
    <div class="title">我的订单</div>
    <div class="switchButton">
      <div class="switch-item" @click="switchActive(0)" :class="type == 0 ? 'active' : ''">全部订单</div>
      <div class="switch-item" @click="switchActive(1)" :class="type == 1 ? 'active' : ''">未完成订单</div>
      <div class="switch-item" @click="switchActive(2)" :class="type == 2 ? 'active' : ''">已完成订单</div>
    </div>
    <div class="list_box">
      <div class="list_top">
        <div class="list_col">商品</div>
        <div class="list_col">总价</div>
        <div class="list_col">状态</div>
        <div class="list_col">操作</div>
      </div>
      <div class="list_main">
        <div class="list_item" v-for="(item, index) in list" :key="index">
          <div class="list_item_top">
            <div>订单号：{{ item.order_no }}</div>
            <div>{{ item.submit_time_text }}</div>
          </div>
          <div class="list_item_main">
            <div class="item_info">
              <div class="item_img">
                <img :src="$url.cdn(item['orderGoods'][0].goods_image)" :alt="item['orderGoods'][0].goods_name"/>
              </div>
              <div class="item_desc">
                <div class="item_desc_title"><span v-for="(item1, index1) in item['orderGoods']" :key="index1">{{item1.goods_name}} </span>
                </div>
                <div class="item_desc_toast">支持七天内退换货（特殊定制探针除外）</div>
              </div>
            </div>
            <div class="item_total">￥{{item.discount_price}}</div>
            <div class="item_status">{{ item.status_text }}</div>
            <div class="item_btns">
              <router-link class="item_btn item_btn_red" :to="'/PerSonalLayout/OrderInfo/' + item.id">订单详情</router-link>
              <router-link v-if="item.orderInfo" class="item_btn item_btn_white" :to="'/PerSonalLayout/ContractInfo/' + item.orderInfo.id">查看合同</router-link>
            </div>
          </div>
        </div>
      </div>
      <el-pagination layout="prev, pager, next" @current-change="pageChange" :total="total"></el-pagination>
    </div>
  </div>
</template>
<script>
  import contractApi from '@/api/contract'
  export default {
    data() {
      return {
        page : 1,
        limit: 10,
        type : 0,
        list : [],
        total: 0
      };
    },
    created() {
      this.$emit("getCompontsIndex", 1);
      this.getOrderList();
    },
    methods: {
      goodsDetail(id) {
        this.$router.push({path: '/GoodsDetail?id=' + id});
      },
      pageChange(e) {
        this.page = e;
        this.getOrderList();
      },
      async getOrderList() {
        let {data: orderList} = await contractApi.order.list({
            type : this.type,
            page : this.page,
            list_rows: this.limit
        })
        this.list = orderList.data || [];
        this.total = orderList.total || 0;
      },
      // 切换列表
      switchActive(e) {
        this.type = e;
        this.getOrderList();
      }
    }
  };
</script>
<style lang="less" scoped>
  @import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/components/personal-info/my-order.vue